import styled from "styled-components";

export const Divider = styled.div`
  height: 0;
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  border-bottom: 1px solid #bdbdbd;
`;
